import React from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {layoutActions} from 'features/layout/redux';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import {DialogTypes} from 'common/names';

type Props = {
   cancel: () => void;
};

const AuditSuspensionForm = ({cancel}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   React.useEffect(() => {
      dispatch(layoutActions.suspendTransactionFolder());
   }, [dispatch]);
   return (
      <>
         <Typography gutterBottom>{t('Suspending job scheduling')}...</Typography>
         <Box textAlign={'center'}>
            <Button type="button" onClick={cancel}>
               {t('Cancel')}
            </Button>
         </Box>
      </>
   );
};

type DialogProps = {
   onClose: () => void;
};
export const AuditSuspensionDialog = ({onClose}: DialogProps) => {
   return (
      <Dialog maxWidth="sm" header={DialogTypes.AuditSuspensionDialog.dialogName} close={onClose}>
         <AuditSuspensionForm cancel={onClose} />
      </Dialog>
   );
};

export default React.memo(AuditSuspensionDialog);
